import { Document } from '@tiptap/extension-document';

import type { MaDocumentType } from '@/lib/zybooks-api';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        zyDocument: {
            setDocAttribute: (name: string, value: any) => ReturnType;
            setDocAttributes: (attributes: Partial<ZyDocumentAttributes>) => ReturnType;
        };
    }
}

export interface ZyDocumentAttributes {
    zybookCode: string | null;
    zybookId: number | null;
    maDocumentId: number | null;
    baseImageUrl: string | null;
    sectionId: string | null;
    releaseId: number | string | null;
    subjectName: string | null;
    chapterNumber: number | null;
    sectionNumber: number | null;
    uploadImagesToMATESTBucket: boolean;
    title: Record<string, string>;
    documentType: MaDocumentType | null;
    documentId: number | null;
}

export interface ZyDocumentOptions {
    content?: string | null;
    attributes?: Partial<ZyDocumentAttributes>;
}

const skipMeta = [
    // Skip table of contents update
    'composition',
    'toc',
];

export const ZyDocument = Document.extend({
    addOptions() {
        return {
            content: null,
            attributes: {},
        };
    },

    content: function () {
        return this.options.content ?? 'block+';
    },

    addAttributes() {
        return {
            zybookCode: {
                default: this.options.attributes?.zybookCode ?? null,
            },
            zybookId: {
                default: this.options.attributes?.zybookId ?? null,
            },
            maDocumentId: {
                default: this.options.attributes?.maDocumentId ?? null,
            },
            baseImageUrl: {
                default: this.options.attributes?.baseImageUrl ?? null,
            },
            sectionId: {
                default: this.options.attributes?.sectionId ?? null,
            },
            releaseId: {
                default: this.options.attributes?.releaseId ?? null,
            },
            subjectName: {
                default: this.options.attributes?.subjectName ?? null,
            },
            chapterNumber: {
                default: this.options.attributes?.chapterNumber ?? null,
            },
            sectionNumber: {
                default: this.options.attributes?.sectionNumber ?? null,
            },
            uploadImagesToMATESTBucket: {
                default: this.options.attributes?.uploadImagesToMATESTBucket ?? false,
            },
            title: {
                default: this.options.attributes?.title ?? {},
            },
            documentType: {
                default: this.options.attributes?.documentType ?? null,
            },
            documentId: {
                default: this.options.attributes?.documentId ?? null,
            },
        };
    },

    addCommands() {
        return {
            setDocAttribute:
                (name: string, value: any) =>
                ({ tr, dispatch }) => {
                    if (dispatch) {
                        skipMeta.forEach(meta => tr.setMeta(meta, true));
                        tr.setDocAttribute(name, value);
                    }
                    return true;
                },
            setDocAttributes:
                (attributes: Partial<ZyDocumentAttributes>) =>
                ({ tr, dispatch }) => {
                    skipMeta.forEach(meta => tr.setMeta(meta, true));
                    if (dispatch) {
                        for (const [key, value] of Object.entries(attributes)) {
                            tr.setDocAttribute(key, value ?? null);
                        }
                    }
                    return true;
                },
        };
    },
});
